import type { ReactNode } from 'react';
import { Fragment } from 'react';

import { useMapStore } from '@/stores/useMapStore';
import type { MapState } from '@/types/MapState';

interface LayerVisibleProps {
  layer: keyof MapState['layersControl'];
  children: ReactNode;
}

export function LayerVisible({ layer, children }: LayerVisibleProps) {
  const layersControl = useMapStore((state) => state.layersControl);

  return layersControl[layer] ? <Fragment>{children}</Fragment> : null;
}
